import { InstanceBadge } from './InstanceBadge';
import styles from '../InterventionGraphEditor.module.css';

interface DependencyTargetOptionProps {
  label: string;
  name: string;
}

// Option row for the dependency-target picker: instance badge + intervention name.
export const DependencyTargetOption = ({ label, name }: DependencyTargetOptionProps) => (
  <span className={styles.optionWithBadge}>
    <InstanceBadge label={label} />
    {name}
  </span>
);
